module.exports = __webpack_public_path__ + "static/img/attack_spanish_dark.101dac4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attack_spanish_dark.png
// module id = OxzC
// module chunks = 94